import style from "./style.scss";

import DownloadLink from "../../components/download-link";

const DownloadItem = ({ title, image, file = null, files = null }) => {
  let defaultFile = file;
  if (files && !file) {
    defaultFile = files[0].file;
  }

  return (
    <div class={style.downloadItem}>
      <h3>
        {title}{" "}
        <span class={style.files}>
          (
          {files && files.length > 1 ? (
            files.map((item, index) => (
              <span key={index}>
                <DownloadLink file={item.file}>{item.name}</DownloadLink>
              </span>
            ))
          ) : (
            <span>
              <DownloadLink file={defaultFile}>Download</DownloadLink>
            </span>
          )}
          )
        </span>
      </h3>
      <DownloadLink file={defaultFile}>
        <img src={image} alt={`Preview of file: ${title}`} />
      </DownloadLink>
    </div>
  );
};

export default DownloadItem;
